import { Menu } from "antd";
import { default as classnames, default as classNames } from "classnames";
import TweenOne from "rc-tween-one";
import React from "react";
import { Link } from "react-router-dom";
import { AdaptionSection } from "../../../components/AdaptionSection";
import { prefix, yituHomeUrl } from "../../../config";
import LogoImageSrc from "./images/logo.svg";
import "./index.scss";
import { ToggleButton } from "./ToggleButton";

export const YituLogo: React.SFC<{
  className?: string;
}> = props => {
  const { className } = props;
  const prefix = "YituLogo";
  return (
    <a className={classNames(className, prefix)} href={yituHomeUrl}>
      <img style={{ width: "100%" }} src={LogoImageSrc} />
    </a>
  );
};

const clsPrefix = "AppHeader";

interface IAppHeaderProps {
  isMobile: boolean;
  /**
   * 点击
   */
  onClickPartner: () => void;
  /**
   * 点击业务咨询
   */
  onClickConsult: () => void;
}

interface IState {
  phoneOpen: boolean;
}

export class AppHeader extends React.Component<IAppHeaderProps, IState> {
  constructor(props: IAppHeaderProps) {
    super(props);
    this.state = {
      phoneOpen: false
    };
  }

  handlePhoneClick = () => {
    const phoneOpen = !this.state.phoneOpen;
    this.setState({
      phoneOpen
    });
  };

  menuToggleButtonRender() {
    const { isMobile } = this.props;
    const { phoneOpen } = this.state;
    return (
      isMobile && (
        <ToggleButton isOpen={phoneOpen} onClick={this.handlePhoneClick} />
      )
    );
  }

  menuRender() {
    const { phoneOpen } = this.state;
    const { isMobile, onClickConsult, onClickPartner } = this.props;
    const moment = phoneOpen ? 300 : undefined;

    return (
      <TweenOne
        className={`${clsPrefix}-menuWrap`}
        animation={
          isMobile
            ? {
                height: 0,
                duration: 300,
                onComplete: e => {
                  if (this.state.phoneOpen) {
                    e.target.style.height = "auto";
                  }
                },
                ease: "easeInOutQuad"
              }
            : { height: 60 }
        }
        moment={moment}
        reverse={!!phoneOpen}
      >
        <Menu
          className={`${clsPrefix}-menu`}
          mode={isMobile ? "inline" : "horizontal"}
          defaultSelectedKeys={["sub0"]}
          theme="dark"
        >
          <Menu.Item className={`${clsPrefix}-menuItem`}>
            <Link to={`${prefix}/`}>首页</Link>
          </Menu.Item>
          <Menu.Item
            className={`${clsPrefix}-menuItem`}
            onClick={onClickPartner}
          >
            成为伙伴
          </Menu.Item>
          <Menu.Item className={`${clsPrefix}-menuItem`}>
            <Link to={`${prefix}/searchPartner`}>查找伙伴</Link>
          </Menu.Item>
          <Menu.Item
            className={`${clsPrefix}-menuItem`}
            onClick={onClickConsult}
          >
            业务咨询
          </Menu.Item>
          <Menu.Item className={`${clsPrefix}-menuItem`}>
            <a href={`${prefix}/#activity`}>活动资讯</a>
          </Menu.Item>
          <Menu.Item className={`${clsPrefix}-loginButton`}>
            <a href="/corporate/login">
              <div
                className={classnames(!isMobile && `${clsPrefix}-loginItem`)}
              >
                登录
              </div>
            </a>
          </Menu.Item>
        </Menu>
      </TweenOne>
    );
  }

  render() {
    const { isMobile } = this.props;
    const { phoneOpen } = this.state;

    return (
      <div
        className={classnames(`${clsPrefix}`, {
          [`${clsPrefix}--open`]: phoneOpen,
          [`${clsPrefix}--mobile`]: isMobile
        })}
      >
        <AdaptionSection>
          <TweenOne component="header" animation={{ opacity: 0, type: "from" }}>
            <div className={`${clsPrefix}-content`}>
              <YituLogo className={`${clsPrefix}-logo`} />
              {this.menuToggleButtonRender()}
              {this.menuRender()}
            </div>
          </TweenOne>
        </AdaptionSection>
      </div>
    );
  }
}

export { LogoImageSrc };
